import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App";
import ServicesLanding from "../views/ServicesLanding"
import NdomanoCapital from "../views/NdomanoCapital"
import NdomanoMotors from "../views/NdomanoMotors"
import NdomanoLogistics from "../views/NdomanoLogistics"
import NdomanoPharmaceuticals from "../views/NdomanoPharmaceuticals"
import WereniumTech from "../views/WereniumTech"

export default function Services(props) {

	const appContext = useContext(AppContext);

	const [ view, setView ] = useState(null);

	async function init() {
		//run initializations here
	}

	function getView() {
		const { navSubItem, navExtraItem, navMoreItem } = appContext;

		if (!navSubItem && !navExtraItem && !navMoreItem) {
			return <ServicesLanding />;
		}

		// normalize incoming subitem values so we accept variants like
		// "Ndomano_Capital", "ndomano-capital", "Ndomano Capital"
		const normalized = (navSubItem || '').toString().toLowerCase().replace(/[_\s]+/g, '-');

		if (normalized === 'ndomano-capital' ) return <NdomanoCapital />;
		if (normalized === 'ndomano-motors' ) return <NdomanoMotors />;
		if (normalized === 'ndomano-logistics' ) return <NdomanoLogistics />;
		if (normalized === 'ndomano-pharmaceuticals' ) return <NdomanoPharmaceuticals />;
		if (normalized === 'werenium-technologies' || normalized === 'werenium-tech' || normalized === 'werenium') return <WereniumTech />;

		return null;
	}


	useEffect(() => {
		init();
	}, [ ])

	useEffect(() => {
		const _view = getView();
		if(_view) {
			setView(_view);
		}
	}, [ appContext.navSubItem, appContext.navExtraItem, appContext.navMoreItem ])

	//return desired view
	return view;
}